import { AvField } from "availity-reactstrap-validation"
import React, { useEffect, useState } from "react"
import { Button, Col, Row } from "reactstrap"
import Item from "./Item"

const ConsumptionItems = props => {
  const [itemsRaw, setitemsRaw] = useState([])
  const [itemsList, setitemsList] = useState([])

  useEffect(() => {
    setitemsRaw(props.data)
    
    const itemsList = props.data.map((item, index) => {
      return (
        <Item
          key={index}
          index={index}
          checked={item.checked}
          value={item.name}
          update={updateItemStatus}
        />
      )
    })
    setitemsList(itemsList)
  }, [props.data])

  const updateItemStatus = (index, status) => {
    props.update(index, status)
  }

  const updateOtherItems = (items) => {
    setotherItems(items)
  }

  const addOtherItem = (item) => {
    props.updateOthers(item)
  }

  return (
    <>
      {itemsList}
    </>
  )
}

// const OtherItemsButton = props => {
//   const [otherItems, setotherItems] = useState([])
//   const [currentItem, setcurrentItem] = useState("")
//   const [itemsDiv, setitemsDiv] = useState([])

//   useEffect(()=>{
//     setotherItems(props.data)
//     setcurrentItem("")
//     populateItemsDiv()
//     console.log("yooooooo")
//   }, [props.data])

//   const addItem = () => {
//     if (currentItem == "" || otherItems.includes(currentItem)) {
//       return
//     }

//     props.add(currentItem)

//     // let items = otherItems
//     // items.push(currentItem)
//     // setcurrentItem("")

//     // console.log(otherItems)
//     // populateItemsDiv()
//   }

//   const changeCurrentItem = (e) => {
//     let item = e.target.value.trim()
//     if (item == "") {
//       return
//     }
//     setcurrentItem(item)
//   }

//   const updateItem = (item) => {
//     props.update(item)
//   }

//   const populateItemsDiv = () => {
//     let divItems = otherItems.map((item, index)=>{
//       return  <Item
//       key={index}
//       index={index}
//       checked={item.checked}
//       value={item}
//       update={updateItem}
//     />
//     })

//     setitemsDiv(divItems)
//   }

//   return (
//     <>
//       <div>
//         <Row>
//           <Col md={8}>
//             <AvField
//               type="text"
//               name="consumption_item"
//               placeholder="Enter custom consumption item"
//               value = {currentItem}
//               onChange={changeCurrentItem}
//             ></AvField>
//           </Col>

//           <Col md={4}>
//             <a className="btn btn-primary" onClick={addItem}>Add</a>
//           </Col>
//         </Row>
//       </div>
//     </>
//   )
// }

// const Item = props => {
//   const [index, setindex] = useState(props.index)
//   const [id, setid] = useState(props.id)
//   const [value, setvalue] = useState(props.value)
//   const [checked, setchecked] = useState(props.checked)

//   useEffect(() => {
//     setchecked(props.checked)
//   }, [props.checked])

//   const changeChecked = e => {
//     if (e.target.checked) {
//       setchecked(true)
//     } else {
//       setchecked(false)
//     }
//     props.update(index, e.target.checked)
//   }

//   return (
//     <div className="form-check">
//       <input
//         onChange={changeChecked}
//         type="checkbox"
//         className="form-check-input"
//         checked={checked}
//       ></input>
//       <label className="form-check-label">{props.value}</label>
//     </div>
//   )
// }

export default ConsumptionItems
